import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { ModalController, ToastController } from "@ionic/angular";

@Component({
  selector: "app-secure-refund-close-case",
  templateUrl: "./refund-close-case.component.html",
})
export class RefundCloseComponent implements OnInit {
  closeForm: FormGroup = new FormGroup({});
  pan: string;
  applicantName: string;

  constructor(
    private modalCtrl: ModalController,
    private toastController: ToastController
  ) {}

  ngOnInit(): void {
    this.closeForm = new FormGroup({
      closeReason: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(2000),
      ]),
    });
  }

  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

  close() {
    if (!this.closeForm.value.closeReason) {
      this.showErrorToast("Please Enter Reject Reason");
    }
    if (confirm("Are you sure to Close this applicant  -" + this.pan + ".")) {
      if (this.closeForm.valid) {
        return this.modalCtrl.dismiss(
          this.closeForm.value.closeReason,
          "CLOSE"
        );
      }
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }
}
